import $ from 'jquery';
import runOnVisible from '../runner-visible';

export default function counterStatistic() {
  function counter(el) {
    let $this = $(el),
      countTo = $this.find('.counter-up-statistic__number').attr('data-counter');
    $({countNum: $this.find('.counter-up-statistic__number').text()}).animate({
        countNum: countTo,
      },

      {
        duration: 2000,
        easing:'linear',

        step: function() {
          $this.find('.counter-up-statistic__number').text(Math.floor(this.countNum));
        },
        complete: function() {
          $this.find('.counter-up-statistic__number').text(this.countNum);
        },
      });
  }

  const counters = document.getElementsByClassName('counter-up-statistic__inner-box');
  for (const counter1 of counters) {
    runOnVisible(counter1, () => {
      counter(counter1);
    });
  }
}
